export const translations = {
  es: {
    // Brand
    appName: "Album - MFcreativemanager",
    appTagline: "Hecho con amor para momentos especiales",
    
    // Navigation
    back: "Volver",
    backToSite: "Volver al sitio",
    admin: "ADMIN",
    
    // Landing Page
    heroTitle: "Captura el momento,",
    heroTitleAccent: "no solo la pose.",
    heroSubtitle: "El álbum de fotos instantáneo y sin app para tu boda o fiesta. Escanea, captura y comparte.",
    findYourAlbum: "Encuentra tu álbum",
    findTheAlbum: "INVITADO... Busca el álbum del evento",
    searchPlaceholder: "Buscar por nombre o código...",
    enterEventCodeOrName: "Nombre o código del evento",
    search: "Buscar",
    noAlbumsFound: "No se encontraron álbumes para",
    photosUploaded: "fotos subidas hoy",
    
    // How it works
    howItWorks: "Cómo funciona",
    howItWorksSubtitle: "Tres simples pasos para compartir las fotos de tu evento",
    step: "Paso",
    step1Title: "Escanea el código QR",
    step1Desc: "Encuentra el código QR en el lugar del evento",
    step2Title: "Sube tus fotos",
    step2Desc: "Comparte tus mejores momentos al instante",
    step3Title: "Ver y descargar",
    step3Desc: "Accede a todas las fotos de la galería del evento",
    
    // Any Event Section
    anyEventSectionLabel: "Para todo tipo de eventos",
    anyEventTitle: "No solo bodas y fiestas",
    anyEventSubtitle: "Tu álbum digital funciona perfectamente en cualquier tipo de evento donde quieras capturar momentos especiales",
    conferenceTitle: "Conferencias y Seminarios",
    conferenceDesc: "Los asistentes escanean el QR, toman fotos de las ponencias, networking y momentos clave, y las comparten al instante en el álbum del evento.",
    expoTitle: "Exposiciones y Ferias",
    expoDesc: "Captura cada stand, producto y momento memorable. Los visitantes contribuyen con sus propias perspectivas del evento.",
    corporateTitle: "Eventos Corporativos",
    corporateDesc: "Team buildings, lanzamientos de producto, capacitaciones. Todos los colaboradores pueden subir sus fotos a un solo lugar.",
    anyEventCTA: "¡Perfecto para cualquier reunión donde quieras crear memorias compartidas!",
    
    // Album Page
    photosUploaded: "fotos subidas",
    photoUploaded: "foto subida",
    copyLink: "Copiar enlace",
    downloadAll: "Descargar todo",
    downloadQR: "Descargar QR",
    qrDownloaded: "QR descargado",
    qrShared: "QR listo para guardar",
    qrCode: "Código QR",
    shareQRCode: "Compartir código QR",
    qrScanText: "Los invitados pueden escanear este código para subir fotos al instante",
    download: "Descargar",
    delete: "Eliminar",
    noPhotosYet: "Aún no hay fotos",
    noPhotosDesc: "Comparte el código QR con tus invitados para empezar a recolectar fotos",
    waitingForPhotos: "Esperando fotos...",
    albumNotFound: "Álbum no encontrado",
    goHome: "Ir al inicio",
    linkCopied: "¡Enlace copiado!",
    preparingDownload: "Preparando descarga...",
    
    // Upload Page
    addPhotosToAlbum: "Añade tus fotos al álbum",
    tapToAddPhotos: "Toca para añadir fotos",
    dragDropText: "o arrastra y suelta tus imágenes aquí",
    addPhotos: "Añadir fotos",
    uploading: "Subiendo",
    recentUploads: "Subidas recientes",
    photosAddedToGallery: "Fotos añadidas a la galería",
    viewFullGallery: "Ir a cargar fotos",
    gallery: "Galería",
    
    // Guest Gallery
    albumGallery: "Galería del álbum",
    hidePhoto: "Ocultar foto",
    showPhoto: "Mostrar foto",
    photoHidden: "Foto ocultada",
    photoHiddenMessage: "La foto se ocultó de esta vista, pero el administrador aún puede verla.",
    photoHiddenAdmin: "Foto ocultada de la galería pública",
    photoShown: "Foto visible en la galería pública",
    downloadAllPhotos: "Descargar todas",
    noPhotosInGallery: "Aún no hay fotos en la galería",
    beFirstToUpload: "¡Sé el primero en subir una foto!",
    uploadPhotoOnEventDay: "Puedes subir tus fotos el día del evento",
    hiddenPhotos: "Fotos ocultas",
    photoHiddenByGuests: "foto oculta por invitados",
    photosHiddenByGuests: "fotos ocultas por invitados",
    confirmHidePhoto: "¿Ocultar esta foto?",
    hidePhotoWarning: "La foto se ocultará de la galería pública, pero el anfitrión aún podrá verla y solo él puede eliminarla permanentemente.",
    swipeToNavigate: "Desliza para navegar",
    swipeDownToClose: "Desliza hacia abajo para cerrar",
    
    // Admin Page
    adminDashboard: "Panel de administración",
    manageAlbumsPhotos: "Gestiona todos los álbumes y fotos",
    totalAlbums: "Total de álbumes",
    totalPhotos: "Total de fotos",
    allAlbums: "Todos los álbumes",
    createAlbum: "Crear álbum",
    createNewAlbum: "Crear nuevo álbum",
    albumName: "Nombre del álbum",
    albumNamePlaceholder: "ej. Boda de María y Juan",
    cancel: "Cancelar",
    saveChanges: "Guardar cambios",
    creating: "Creando...",
    editAlbum: "Editar álbum",
    photos: "Fotos",
    edit: "Editar",
    noAlbumsCreated: "No hay álbumes creados aún",
    deleteAlbum: "¿Eliminar álbum?",
    deleteAlbumDesc: "Esto eliminará permanentemente el álbum y todas sus fotos. Esta acción no se puede deshacer.",
    albumCreated: "¡Álbum creado! Código:",
    albumDeleted: "Álbum eliminado correctamente",
    albumUpdated: "Álbum actualizado correctamente",
    photoDeleted: "Foto eliminada",
    deletePhotoConfirm: "¿Eliminar esta foto?",
    deletePhotoDesc: "Esta acción eliminará la foto permanentemente. No se puede deshacer.",
    noPhotosInAlbum: "No hay fotos en este álbum",
    
    // Common
    photo: "foto",
    photos: "fotos",
    code: "Código",
    eventName: "Nombre del evento",
    failedToLoad: "Error al cargar",
    searchFailed: "Búsqueda fallida. Intenta de nuevo.",
    minSearchChars: "Ingresa al menos 2 caracteres para buscar",
    albumNotFoundError: "Álbum no encontrado. Verifica el código o nombre e intenta de nuevo.",
    albumExists: "Ya existe un álbum con este nombre. Por favor elige otro nombre.",
    enterAlbumCode: "Ingresa el código o nombre del álbum",
    uploadFailed: "Error al subir fotos. Intenta de nuevo.",
    selectImagesOnly: "Por favor selecciona solo archivos de imagen",
    maxFilesWarning: "Máximo 10 fotos por carga. Se subirán las primeras 10.",
    failedToDelete: "Error al eliminar",
    failedToCopy: "Error al copiar enlace",
    failedToDownload: "Error al descargar",
    photoShared: "Guarda la imagen en tu galería",
    failedToCreate: "Error al crear álbum",
    failedToUpdate: "Error al actualizar",
    enterAlbumName: "Por favor ingresa un nombre para el álbum",
    albumNameEmpty: "El nombre del álbum no puede estar vacío",
    
    // Authentication
    adminLogin: "Acceso Administrador",
    loginToManage: "Inicia sesión para gestionar tus álbumes",
    username: "Usuario",
    enterUsername: "Ingresa tu usuario",
    login: "Iniciar Sesión",
    loggingIn: "Iniciando sesión...",
    logout: "Salir",
    logoutSuccess: "Sesión cerrada exitosamente",
    loginSuccess: "¡Bienvenido!",
    invalidCredentials: "Usuario o contraseña incorrectos",
    fillAllFields: "Por favor completa todos los campos",
    backToHome: "Volver al inicio",
    
    // Client access
    imTheHost: "¿Eres el anfitrión? Accede aquí",
    clientAccess: "Acceso a tu álbum",
    clientAccessDesc: "Ingresa con el código y contraseña que te proporcionaron",
    albumCodeOrName: "Código o nombre del álbum",
    enterAlbumCode: "Ej: Mi Boda 2025 o abc123",
    albumPassword: "Contraseña del Álbum",
    albumPasswordDesc: "El anfitrión usará esta contraseña para administrar el álbum",
    enterAlbumPassword: "Contraseña proporcionada",
    verifying: "Verificando...",
    accessMyAlbum: "Acceder a mi álbum",
    albumBenefits: "¿Qué puedes hacer con tu álbum?",
    downloadPhotos: "Descarga todas las fotos",
    downloadPhotosDesc: "Descarga las fotos individuales o todas en un ZIP con un solo clic",
    hidePhotos: "Oculta fotos",
    hidePhotosDesc: "Oculta fotos de la vista de los invitados sin eliminarlas",
    deletePhotos: "Elimina fotos",
    deletePhotosDesc: "Elimina permanentemente las fotos que no desees",
    clientTip: "Tu contraseña fue proporcionada por MFcreativemanager",
    clientTipDesc: "Si no la tienes, contacta por Instagram @mfcreativemanager",
    welcomeToAlbum: "¡Bienvenido a tu álbum!",
    incorrectPassword: "Contraseña incorrecta",
    albumNotPrivate: "Este álbum es público. Usa la búsqueda de invitados.",
    errorOccurred: "Ocurrió un error. Intenta de nuevo.",
    
    // Photo limits
    photoLimit: "Límite de fotos",
    unlimited: "Ilimitado",
    photosLimit: "fotos",
    selectPhotoLimit: "Seleccionar capacidad",
    albumFull: "El álbum ha alcanzado su límite de fotos",
    remainingPhotos: "fotos restantes",
    albumAlmostFull: "¡Tu álbum está casi lleno!",
    contactToUpgrade: "Contacta a MFcreativemanager para incrementar el plan.",
    
    // Landing page plans
    albumPlans: "Planes de álbumes",
    albumPlansSubtitle: "Elige la capacidad perfecta para tu evento",
    contactForPlan: "Contáctanos en Instagram para adquirir tu plan",
    basicPlan: "Básico",
    standardPlan: "Estándar",
    premiumPlan: "Premium",
    unlimitedPlan: "Ilimitado",
    perfectFor: "Perfecto para",
    smallEvents: "eventos pequeños",
    mediumEvents: "eventos medianos",
    largeEvents: "eventos grandes",
    anyEvent: "cualquier evento",
    
    // Partnerships Section
    partnershipsLabel: "Alianzas Estratégicas",
    partnershipsTitle: "¿Eres planner o decorador de eventos?",
    partnershipsSubtitle: "Únete a nuestra red de aliados y ofrece a tus clientes una experiencia única para capturar los mejores momentos de sus eventos",
    eventPlannersTitle: "Event Planners",
    eventPlannersDesc: "Agrega valor a tus servicios de planificación con álbumes digitales interactivos para bodas, quinceañeras, corporativos y más.",
    decoratorsTitle: "Decoradores de Eventos",
    decoratorsDesc: "Complementa tus increíbles decoraciones con una forma moderna de que los invitados capturen y compartan la magia del evento.",
    specialPricing: "Precios especiales para tus clientes",
    partnershipCTA: "Quiero ser aliado",
    partnershipNote: "Contáctanos por Instagram para más información",
    
    // Admin settings
    settings: "Configuración",
    heroImage: "Imágenes del carrusel",
    heroImages: "Imágenes del carrusel",
    changeHeroImage: "Agregar imagen",
    uploadNewImage: "Subir nueva imagen",
    currentImage: "Imagen actual",
    currentImages: "Imágenes actuales",
    imageUpdated: "Imagen actualizada correctamente",
    failedToUploadImage: "Error al subir la imagen",
    maxImagesReached: "Máximo 3 imágenes. Elimina una primero.",
    deleteImage: "Eliminar imagen",
    noImagesUploaded: "No hay imágenes. Sube al menos una imagen para el carrusel.",
    imageDeleted: "Imagen eliminada",
    addImage: "Agregar imagen",
    imagesCount: "imágenes",
    
    // Counter settings
    photoCounter: "Contador de fotos",
    showPhotoCounter: "Mostrar contador de fotos",
    counterEnabled: "El contador está visible en la landing page",
    counterDisabled: "El contador está oculto en la landing page",
    
    // Hero image reordering
    moveUp: "Mover arriba",
    moveDown: "Mover abajo",
    orderUpdated: "Orden actualizado",
    
    // Privacy settings
    private: "Privado",
    public: "Público",
    publicAlbum: "Álbum público",
    privateAlbum: "Álbum privado",
    publicAlbumDesc: "Cualquiera con el enlace puede ver y subir fotos",
    privateAlbumDesc: "Se requiere contraseña para acceder al álbum",
    password: "Contraseña",
    enterPassword: "Ingresa una contraseña",
    changePassword: "Cambiar contraseña",
    
    // Massive Event Mode
    massiveEventMode: "Modo Evento Masivo",
    massiveEventDesc: "Activa para eventos con muchos asistentes como conferencias, exposiciones o festivales",
    massiveEventName: "Nombre del evento masivo",
    massiveEventNamePlaceholder: "Ej: Tech Summit 2025",
    massiveEventInstagram: "Instagram del evento",
    massiveEventInstagramPlaceholder: "@mievento",
    massiveEventHashtags: "Hashtags oficiales",
    massiveEventHashtagsPlaceholder: "#MiEvento2025 #TechSummit",
    massiveEventMessage: "Mensaje para invitados",
    massiveEventMessagePlaceholder: "¡Bienvenido! Comparte tus mejores momentos del evento...",
    massiveEventDuration: "Duración del evento",
    massiveEventStartDate: "Fecha de inicio",
    massiveEventEndDate: "Fecha de fin",
    massiveEventCoverImage: "Portada del evento",
    massiveEventUploadCover: "Subir imagen de portada",
    massiveEventActive: "Evento en vivo",
    uploadAvailableDuring: "Carga disponible del",
    to: "al",
    eventNotStarted: "El evento aún no ha comenzado",
    eventEnded: "El período de carga ha finalizado",
    uploadAvailableFrom: "Podrás subir fotos a partir del",
    shareYourPhotos: "¡Comparte tus mejores momentos!",
    beFirstToCapture: "¡Sé el primero en capturar el momento!",
    yourPhotosPrivate: "Tus fotos solo las verás tú hasta que el anfitrión las haga públicas",
    officialPhoto: "Foto oficial",
    markAsOfficial: "Marcar como oficial",
    removeOfficial: "Quitar de oficiales",
    copiedToClipboard: "¡Copiado al portapapeles!",
    clickToCopy: "Click para copiar",
    photosTab: "Fotos",
    contributorsTab: "Participantes",
    contributorsCopied: "usuarios copiados",
    selected: "seleccionados",
    selectAll: "Seleccionar todos",
    copyUsernames: "Copiar @",
    viewPhotos: "Ver fotos",
    noContributors: "Aún no hay participantes",
    anonymous: "Anónimo",
    yourInstagram: "Tu Instagram (opcional)",
    instagramPlaceholder: "tu_usuario",
    instagramHint: "El anfitrión podrá ver quién subió cada foto",
    shareYourInstagram: "¿Cuál es tu Instagram?",
    instagramMentionHint: "Compártenos tu Instagram para mencionarte en las publicaciones oficiales",
    optionalField: "Este campo es opcional",
    continueUpload: "Continuar y subir fotos",
    deletePhotoTitle: "¿Eliminar esta foto?",
    deletePhotoMessage: "Esta acción no se puede deshacer. La foto se eliminará permanentemente.",
    photoDeleted: "Foto eliminada",
    leaveEmptyToKeep: "Dejar vacío para mantener la actual",
    leaveEmptyToKeepCurrent: "Deja vacío para mantener la contraseña actual",
    passwordRequired: "La contraseña es obligatoria",
    incorrectPassword: "Contraseña incorrecta",
    enterAlbumPassword: "Ingresa la contraseña del álbum",
    accessAlbum: "Acceder al álbum",
    protectedAlbum: "Este álbum está protegido",
    enterPasswordToAccess: "Ingresa la contraseña para ver y subir fotos",
    accessGranted: "Acceso concedido",
    failedToVerify: "Error al verificar la contraseña",
    
    // Contact
    contactUsOnInstagram: "Contáctanos por Instagram",
    
    // Event Date & Expiration
    eventDate: "Fecha del evento",
    selectEventDate: "Seleccionar fecha",
    eventDateOptional: "La fecha del evento es opcional",
    albumAvailable3Months: "Álbum disponible por 3 meses",
    albumExpiresOn: "Se eliminará el",
    expiresOn: "Expira el",
    daysRemaining: "días restantes",
    dayRemaining: "día restante",
    uploadsAllowedUntil: "Subidas permitidas hasta el",
    uploadsNotAllowed: "Las subidas ya no están permitidas",
    uploadWindowClosed: "El período de carga ha finalizado",
    uploadWindowClosedDesc: "Solo se podían subir fotos el día del evento y el día siguiente.",
    uploadNotYetOpen: "El período de carga aún no inicia",
    uploadNotYetOpenDesc: "Podrás cargar tus fotos a partir del",
    onlyAdminCanDelete: "Solo el administrador puede eliminar el álbum",
    expirationNote: "Después de 3 meses el álbum expirará automáticamente",
    
    // Cover Image
    coverImage: "Foto de portada",
    uploadCover: "Subir portada",
    removeCover: "Eliminar portada",
    coverImageOptional: "Opcional - Se mostrará en la parte superior del álbum",
    
    // Create/Edit Album Pages
    createNewAlbum: "Crear nuevo álbum",
    createAlbumDesc: "Configura los detalles de tu nuevo álbum",
    currentPhotos: "Fotos actuales",
  },
  
  en: {
    // Brand
    appName: "Album - MFcreativemanager",
    appTagline: "Made with love for special moments",
    
    // Navigation
    back: "Back",
    backToSite: "Back to Site",
    admin: "ADMIN",
    
    // Landing Page
    heroTitle: "Capture the moment,",
    heroTitleAccent: "not just the pose.",
    heroSubtitle: "The instant, app-free photo album for your wedding or party. Scan, snap, and share.",
    findYourAlbum: "Find Your Album",
    findTheAlbum: "Find the Album",
    searchPlaceholder: "Search by event name or code...",
    enterEventCodeOrName: "Event name or code",
    search: "Search",
    noAlbumsFound: "No albums found matching",
    photosUploaded: "photos uploaded today",
    
    // How it works
    howItWorks: "How It Works",
    howItWorksSubtitle: "Three simple steps to share your event photos",
    step: "Step",
    step1Title: "Scan QR Code",
    step1Desc: "Find the QR code at your event venue",
    step2Title: "Upload Photos",
    step2Desc: "Share your best moments instantly",
    step3Title: "View & Download",
    step3Desc: "Access all photos from the event gallery",
    
    // Any Event Section
    anyEventSectionLabel: "For all types of events",
    anyEventTitle: "Not just weddings and parties",
    anyEventSubtitle: "Your digital album works perfectly for any type of event where you want to capture special moments",
    conferenceTitle: "Conferences & Seminars",
    conferenceDesc: "Attendees scan the QR, take photos of presentations, networking and key moments, and share them instantly in the event album.",
    expoTitle: "Exhibitions & Trade Shows",
    expoDesc: "Capture every booth, product and memorable moment. Visitors contribute with their own perspectives of the event.",
    corporateTitle: "Corporate Events",
    corporateDesc: "Team buildings, product launches, trainings. All collaborators can upload their photos to one place.",
    anyEventCTA: "Perfect for any gathering where you want to create shared memories!",
    
    // Album Page
    photosUploaded: "photos uploaded",
    photoUploaded: "photo uploaded",
    copyLink: "Copy Link",
    downloadAll: "Download All",
    downloadQR: "Download QR",
    qrDownloaded: "QR downloaded",
    qrShared: "QR ready to save",
    qrCode: "QR Code",
    shareQRCode: "Share QR Code",
    qrScanText: "Guests can scan this code to upload photos instantly",
    download: "Download",
    delete: "Delete",
    noPhotosYet: "No photos yet",
    noPhotosDesc: "Share the QR code with your guests to start collecting photos",
    waitingForPhotos: "Waiting for photos...",
    albumNotFound: "Album not found",
    goHome: "Go Home",
    linkCopied: "Link copied to clipboard!",
    preparingDownload: "Preparing download...",
    
    // Upload Page
    addPhotosToAlbum: "Add your photos to the album",
    tapToAddPhotos: "Tap to add photos",
    dragDropText: "or drag and drop your images here",
    addPhotos: "Add Photos",
    uploading: "Uploading",
    recentUploads: "Recent uploads",
    photosAddedToGallery: "Photos added to gallery",
    viewFullGallery: "Go to upload photos",
    gallery: "Gallery",
    
    // Guest Gallery
    albumGallery: "Album Gallery",
    hidePhoto: "Hide photo",
    showPhoto: "Show photo",
    photoHidden: "Photo hidden",
    photoHiddenMessage: "The photo was hidden from this view, but the admin can still see it.",
    photoHiddenAdmin: "Photo hidden from public gallery",
    photoShown: "Photo visible in public gallery",
    downloadAllPhotos: "Download all",
    noPhotosInGallery: "No photos in the gallery yet",
    beFirstToUpload: "Be the first to upload a photo!",
    uploadPhotoOnEventDay: "You can upload your photos on the event day",
    hiddenPhotos: "Hidden Photos",
    photoHiddenByGuests: "photo hidden by guests",
    photosHiddenByGuests: "photos hidden by guests",
    confirmHidePhoto: "Hide this photo?",
    hidePhotoWarning: "The photo will be hidden from the public gallery, but the host can still see it and only they can delete it permanently.",
    swipeToNavigate: "Swipe to navigate",
    swipeDownToClose: "Swipe down to close",
    
    // Admin Page
    adminDashboard: "Admin Dashboard",
    manageAlbumsPhotos: "Manage all albums and photos",
    totalAlbums: "Total Albums",
    totalPhotos: "Total Photos",
    allAlbums: "All Albums",
    createAlbum: "Create Album",
    createNewAlbum: "Create New Album",
    albumName: "Album Name",
    albumNamePlaceholder: "e.g., Sarah & John's Wedding",
    cancel: "Cancel",
    saveChanges: "Save Changes",
    creating: "Creating...",
    editAlbum: "Edit Album",
    photos: "Photos",
    edit: "Edit",
    noAlbumsCreated: "No albums created yet",
    deleteAlbum: "Delete Album?",
    deleteAlbumDesc: "This will permanently delete the album and all its photos. This action cannot be undone.",
    albumCreated: "Album created! Code:",
    albumDeleted: "Album deleted successfully",
    albumUpdated: "Album updated successfully",
    photoDeleted: "Photo deleted",
    deletePhotoConfirm: "Delete this photo?",
    deletePhotoDesc: "This action will permanently delete the photo. This cannot be undone.",
    noPhotosInAlbum: "No photos in this album",
    
    // Common
    photo: "photo",
    photos: "photos",
    code: "Code",
    eventName: "Event Name",
    failedToLoad: "Failed to load",
    searchFailed: "Search failed. Please try again.",
    minSearchChars: "Please enter at least 2 characters to search",
    albumNotFoundError: "Album not found. Please check the code or name and try again.",
    albumExists: "An album with this name already exists. Please choose another name.",
    enterAlbumCode: "Enter album code or name",
    uploadFailed: "Failed to upload photos. Please try again.",
    selectImagesOnly: "Please select image files only",
    maxFilesWarning: "Maximum 10 photos per upload. Only the first 10 will be uploaded.",
    failedToDelete: "Failed to delete",
    failedToCopy: "Failed to copy link",
    failedToDownload: "Failed to download",
    photoShared: "Save the image to your gallery",
    failedToCreate: "Failed to create album",
    failedToUpdate: "Failed to update",
    enterAlbumName: "Please enter an album name",
    albumNameEmpty: "Album name cannot be empty",
    
    // Authentication
    adminLogin: "Admin Login",
    loginToManage: "Sign in to manage your albums",
    username: "Username",
    enterUsername: "Enter your username",
    login: "Log In",
    loggingIn: "Logging in...",
    logout: "Logout",
    logoutSuccess: "Successfully logged out",
    loginSuccess: "Welcome!",
    invalidCredentials: "Invalid username or password",
    fillAllFields: "Please fill in all fields",
    backToHome: "Back to home",
    
    // Client access
    imTheHost: "Are you the host? Access here",
    clientAccess: "Access your album",
    clientAccessDesc: "Enter the code and password provided to you",
    albumCodeOrName: "Album code or name",
    enterAlbumCode: "E.g: My Wedding 2025 or abc123",
    albumPassword: "Album Password",
    albumPasswordDesc: "The host will use this password to manage the album",
    enterAlbumPassword: "Password provided",
    verifying: "Verifying...",
    accessMyAlbum: "Access my album",
    albumBenefits: "What can you do with your album?",
    downloadPhotos: "Download all photos",
    downloadPhotosDesc: "Download individual photos or all in a ZIP with one click",
    hidePhotos: "Hide photos",
    hidePhotosDesc: "Hide photos from guests view without deleting them",
    deletePhotos: "Delete photos",
    deletePhotosDesc: "Permanently delete photos you don't want",
    clientTip: "Your password was provided by MFcreativemanager",
    clientTipDesc: "If you don't have it, contact on Instagram @mfcreativemanager",
    welcomeToAlbum: "Welcome to your album!",
    incorrectPassword: "Incorrect password",
    albumNotPrivate: "This album is public. Use the guest search.",
    errorOccurred: "An error occurred. Please try again.",
    
    // Photo limits
    photoLimit: "Photo Limit",
    unlimited: "Unlimited",
    photosLimit: "photos",
    selectPhotoLimit: "Select capacity",
    albumFull: "Album has reached its photo limit",
    remainingPhotos: "photos remaining",
    albumAlmostFull: "Your album is almost full!",
    contactToUpgrade: "Contact MFcreativemanager to upgrade your plan.",
    
    // Landing page plans
    albumPlans: "Album Plans",
    albumPlansSubtitle: "Choose the perfect capacity for your event",
    contactForPlan: "Contact us on Instagram to get your plan",
    basicPlan: "Basic",
    standardPlan: "Standard",
    premiumPlan: "Premium",
    unlimitedPlan: "Unlimited",
    perfectFor: "Perfect for",
    smallEvents: "small events",
    mediumEvents: "medium events",
    largeEvents: "large events",
    anyEvent: "any event",
    
    // Partnerships Section
    partnershipsLabel: "Strategic Partnerships",
    partnershipsTitle: "Are you an event planner or decorator?",
    partnershipsSubtitle: "Join our partner network and offer your clients a unique experience to capture the best moments of their events",
    eventPlannersTitle: "Event Planners",
    eventPlannersDesc: "Add value to your planning services with interactive digital albums for weddings, quinceañeras, corporate events and more.",
    decoratorsTitle: "Event Decorators",
    decoratorsDesc: "Complement your amazing decorations with a modern way for guests to capture and share the magic of the event.",
    specialPricing: "Special pricing for your clients",
    partnershipCTA: "I want to be a partner",
    partnershipNote: "Contact us on Instagram for more information",
    
    // Admin settings
    settings: "Settings",
    heroImage: "Carousel Images",
    heroImages: "Carousel Images",
    changeHeroImage: "Add Image",
    uploadNewImage: "Upload New Image",
    currentImage: "Current Image",
    currentImages: "Current Images",
    imageUpdated: "Image updated successfully",
    failedToUploadImage: "Failed to upload image",
    maxImagesReached: "Maximum 3 images. Delete one first.",
    deleteImage: "Delete image",
    noImagesUploaded: "No images. Upload at least one image for the carousel.",
    imageDeleted: "Image deleted",
    addImage: "Add Image",
    imagesCount: "images",
    
    // Counter settings
    photoCounter: "Photo Counter",
    showPhotoCounter: "Show photo counter",
    counterEnabled: "Counter is visible on landing page",
    counterDisabled: "Counter is hidden on landing page",
    
    // Hero image reordering
    moveUp: "Move up",
    moveDown: "Move down",
    orderUpdated: "Order updated",
    
    // Privacy settings
    private: "Private",
    public: "Public",
    publicAlbum: "Public album",
    privateAlbum: "Private album",
    publicAlbumDesc: "Anyone with the link can view and upload photos",
    privateAlbumDesc: "Password required to access the album",
    password: "Password",
    enterPassword: "Enter a password",
    changePassword: "Change password",
    leaveEmptyToKeep: "Leave empty to keep current",
    leaveEmptyToKeepCurrent: "Leave empty to keep current password",
    passwordRequired: "Password is required",
    incorrectPassword: "Incorrect password",
    enterAlbumPassword: "Enter the album password",
    accessAlbum: "Access album",
    protectedAlbum: "This album is protected",
    enterPasswordToAccess: "Enter the password to view and upload photos",
    accessGranted: "Access granted",
    failedToVerify: "Failed to verify password",
    
    // Massive Event Mode
    massiveEventMode: "Massive Event Mode",
    massiveEventDesc: "Enable for events with many attendees like conferences, exhibitions or festivals",
    massiveEventName: "Massive event name",
    massiveEventNamePlaceholder: "Ex: Tech Summit 2025",
    massiveEventInstagram: "Event Instagram",
    massiveEventInstagramPlaceholder: "@myevent",
    massiveEventHashtags: "Official hashtags",
    massiveEventHashtagsPlaceholder: "#MyEvent2025 #TechSummit",
    massiveEventMessage: "Message for guests",
    massiveEventMessagePlaceholder: "Welcome! Share your best moments from the event...",
    massiveEventDuration: "Event duration",
    massiveEventStartDate: "Start date",
    massiveEventEndDate: "End date",
    massiveEventCoverImage: "Event cover",
    massiveEventUploadCover: "Upload cover image",
    massiveEventActive: "Live event",
    uploadAvailableDuring: "Uploads available from",
    to: "to",
    eventNotStarted: "Event has not started yet",
    eventEnded: "Upload period has ended",
    uploadAvailableFrom: "You can upload photos starting on",
    shareYourPhotos: "Share your best moments!",
    beFirstToCapture: "Be the first to capture the moment!",
    yourPhotosPrivate: "Your photos will only be visible to you until the host makes them public",
    officialPhoto: "Official photo",
    markAsOfficial: "Mark as official",
    removeOfficial: "Remove from official",
    copiedToClipboard: "Copied to clipboard!",
    clickToCopy: "Click to copy",
    photosTab: "Photos",
    contributorsTab: "Contributors",
    contributorsCopied: "users copied",
    selected: "selected",
    selectAll: "Select all",
    copyUsernames: "Copy @",
    viewPhotos: "View photos",
    noContributors: "No contributors yet",
    anonymous: "Anonymous",
    yourInstagram: "Your Instagram (optional)",
    instagramPlaceholder: "your_username",
    instagramHint: "The host will be able to see who uploaded each photo",
    shareYourInstagram: "What's your Instagram?",
    instagramMentionHint: "Share your Instagram so we can mention you in official posts",
    optionalField: "This field is optional",
    continueUpload: "Continue and upload photos",
    deletePhotoTitle: "Delete this photo?",
    deletePhotoMessage: "This action cannot be undone. The photo will be permanently deleted.",
    photoDeleted: "Photo deleted",
    
    // Contact
    contactUsOnInstagram: "Contact us on Instagram",
    
    // Event Date & Expiration
    eventDate: "Event date",
    selectEventDate: "Select date",
    eventDateOptional: "Event date is optional",
    albumAvailable3Months: "Album available for 3 months",
    albumExpiresOn: "Will be deleted on",
    expiresOn: "Expires on",
    daysRemaining: "days remaining",
    dayRemaining: "day remaining",
    uploadsAllowedUntil: "Uploads allowed until",
    uploadsNotAllowed: "Uploads are no longer allowed",
    uploadWindowClosed: "Upload period has ended",
    uploadWindowClosedDesc: "Photos could only be uploaded on the event day and the day after.",
    uploadNotYetOpen: "Upload period has not started yet",
    uploadNotYetOpenDesc: "You can upload your photos starting on",
    onlyAdminCanDelete: "Only the administrator can delete the album",
    expirationNote: "After 3 months the album will expire automatically",
    
    // Cover Image
    coverImage: "Cover photo",
    uploadCover: "Upload cover",
    removeCover: "Remove cover",
    coverImageOptional: "Optional - Will be displayed at the top of the album",
    
    // Create/Edit Album Pages
    createNewAlbum: "Create new album",
    createAlbumDesc: "Set up the details for your new album",
    currentPhotos: "Current photos",
  }
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations.es[key] || key;
};
